<div class="dropdown-container" appClickOutside (clickOutside)="hideMenu()" [isActive]="isMenuShown">
  <div class="trigger" (click)="onTriggerClick($event)">
      <ng-content select="[dropdown-trigger]"></ng-content>
  </div>
  <div class="dropdown-menu"
    *ngIf="isMenuShown"
    (click)="hideMenu()"
    [ngClass]="{'position-left': xPosition!= 'right', 'position-right': xPosition == 'right'}"
    [ngStyle]="top && {'top': top}">
      <ng-content select="[dropdown-menu]"></ng-content>
  </div>
</div>
